<template>
    <div class="w3-content w3-container w3-padding-16">
        <div v-if="route" id="top">
            <div class="w3-margin-bottom">
                <div class="w3-center w3-margin"><a href="#races" v-on:click="$router.push('/routes')" class="cursorpointer w3-text-blue">Vissza a listához</a></div>
                <div class="w3-margin w3-center w3-text-red w3-padding w3-large">A nevezés véglegesítése előtt kérjük ellenőrizze a nevezési adatokat!</div>
                <div class="w3-large uppercase w3-center">Nevezési adatok</div>
                <div v-if="route.price>0" class="w3-center">
                    <p class="uppercase">Útvonal adatai: </p>
                    <table class="w3-table-all w3-small" style="max-width:500px; margin:0 auto">
                        <tr class="" >
                            <td style="width:150px;">Útvonal:</td>
                            <td><b>{{route.name}}</b></td>
                        </tr>                        
                        <tr class="">
                            <td>Táv/Szint:</td>
                            <td>{{route.distance}} km / {{route.level}} m</td>
                        </tr>
                        <tr class="">
                            <td>Fizetendő:</td>
                            <td>{{route.price}} {{$appData.currency}}</td>
                        </tr>
                    </table>    
                    <p class="uppercase">Nevező adatai: </p>
                    <table class="w3-table-all w3-small" style="max-width:500px; margin:0 auto">
                        <tr class="">
                            <td style="width:150px;">Publikus név:</td>
                            <td>{{$store.getters.userProfile.publicName}}</td>
                        </tr>                        
                        <tr class="">
                            <td>Számlázási név:</td>
                            <td>{{$store.getters.userProfile.address.invName}}</td>
                        </tr>
                        <tr class="">
                            <td>Számlázási cím: </td>
                            <td>{{$store.getters.userProfile.address.invCode}} {{$store.getters.userProfile.address.invCity}} {{$store.getters.userProfile.address.invAddress}}</td>
                        </tr>
                        <tr v-if="$store.getters.userProfile.address.invVatNum!=''" class="">
                            <td>Adószám: </td>
                            <td>{{$store.getters.userProfile.address.invVatNum}}</td>
                        </tr>
                        <tr class="">
                            <td>Postázási név: </td>
                            <td>{{$store.getters.userProfile.address.postName}}</td>
                        </tr>
                        <tr class="">
                            <td>Postázási cím: </td>
                            <td>{{$store.getters.userProfile.address.postCode}} {{$store.getters.userProfile.address.postCity}} {{$store.getters.userProfile.address.postAddress}}</td>
                        </tr>
                    </table>                                                    
                </div>
                <div v-else>
                    <table class="w3-table-all w3-small w3-margin-top" style="max-width:500px; margin:0 auto">
                        <tr class="" >
                            <td style="width:200px;">Útvonal neve:</td>
                            <td><b>{{route.name}}</b></td>
                        </tr>                        
                        <tr class="">
                            <td>Táv/Szint:</td>
                            <td>{{route.distance}} km / {{route.level}} m</td>
                        </tr>
                        <tr class="">
                            <td>Fizetendő:</td>
                            <td>{{route.price}} {{$appData.currency}}</td>
                        </tr>
                        <tr class="">
                            <td>Teljesítő publikus neve:</td>
                            <td>{{$store.getters.userProfile.publicName}}</td>
                        </tr>                        
                    </table>    
                </div>
                <div class="w3-center">
                    <button v-on:click="entry()" class="w3-margin w3-button w3-border w3-border-green w3-green w3-hover-white">Nevezés véglegesítése</button>                                                    
                </div>                    
            </div>                           
        </div>
    </div>

</template>

<script>
const fb = require('../firebase.js')
export default {
    name: 'EntryForm',
    data() {
        return {
            route:null
        }
    },
    methods:{
        entry(){          
            var item=this.route;
            if (this.$store.getters.userProfile) {
                fb.IncrementCounter('entry').then(r=>{
                    var status=2;
                    if (item.price>0) status=1;
                    var entryItem={
                        "id":this.$appData.billPrevName+r,
                        "creatDate":Math.floor(Date.now()),
                        "hikeId":item.id,
                        "hikeName":item.name,
                        "payDate":0,
                        "price":item.price,
                        "status":status,
                        "userId":this.$store.getters.userProfile.uid,
                        "userName":this.$store.getters.userProfile.name,
                        "publicName":this.$store.getters.userProfile.publicName,
                        "invName": '',
                        "invAddress": '',
                        "invVatNum": '',
                        "email":''
                    }
                    if (this.$store.getters.userProfile.address) {
                        entryItem.invName=this.$store.getters.userProfile.address.invName;
                        entryItem.invAddress=this.$store.getters.userProfile.address.invCode+' '+this.$store.getters.userProfile.address.invCity+' '+this.$store.getters.userProfile.address.invAddress;
                        if (this.$store.getters.userProfile.address.invVatNum) entryItem.invVatNum=this.$store.getters.userProfile.address.invVatNum;
                    }
                    if (this.$store.getters.userProfile.email) entryItem.email=this.$store.getters.userProfile.email;
                    fb.UpdateEntry(entryItem).then(r=>{   
                        this.$dialog.alert(this.$setDialogMsg('w3-green','Nevezés','Sikeres nevezés!')).then(r=>{
                            this.$router.push({name:'myentries', params: { aktEntryId: entryItem.id, aktEntryPrice: entryItem.price } });                         
                        });
                    }).catch(e=>{
                        console.log(e);
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Nevezés','Hiba történt a művelet során. Kérjük próbálkozzon újra!'));
                    });
                }).catch(e=>{
                    console.log(e);
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Nevezés','Hiba történt a művelet során. Kérjük próbálkozzon újra!'));
                });
            } else {
                this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés!','Nem vagy bejelentkezve. A nevezés előtt kérjük jelentkezz be!'));                
            }
        },
    },
    mounted: function(){
        this.route=this.$route.params.route;
    },
}
</script>
